import React, { useEffect } from "react";

const pineappleImg = "/images/pineapple.png";
const papayaImg = "/images/papaya.png";
const bananaImg = "/images/banana.png";
const mangoImg = "/images/mango.png";

export const FloatingFruits = () => {
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      const x = (e.clientX / window.innerWidth - 0.5) * 2; // -1 to 1
      const y = (e.clientY / window.innerHeight - 0.5) * 2; // -1 to 1

      document.documentElement.style.setProperty("--parallax-x", x.toString());
      document.documentElement.style.setProperty("--parallax-y", y.toString());
    };

    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none z-10">
      {/* Soursop - Top Left */}
      <div
        className="absolute top-[10%] left-[5%] w-28 md:w-40 transition-transform duration-100 ease-out will-change-transform"
        style={{
          transform:
            "translate(calc(var(--parallax-x, 0) * -30px), calc(var(--parallax-y, 0) * -30px))",
        }}
      >
        <div className="animate-float-slow opacity-90 mix-blend-normal">
          <img
            src={pineappleImg}
            alt="Soursop"
            className="w-full h-full object-contain drop-shadow-2xl"
          />
        </div>
      </div>

      {/* Papaya - Bottom Right */}
      <div
        className="absolute bottom-[15%] right-[5%] w-32 md:w-48 transition-transform duration-100 ease-out will-change-transform"
        style={{
          transform:
            "translate(calc(var(--parallax-x, 0) * 40px), calc(var(--parallax-y, 0) * 40px))",
        }}
      >
        <div className="animate-float-medium opacity-90 mix-blend-normal delay-1000">
          <img
            src={papayaImg}
            alt="Papaya"
            className="w-full h-full object-contain drop-shadow-2xl"
          />
        </div>
      </div>

      {/* Banana - Top Right */}
      <div
        className="absolute top-[15%] right-[15%] w-24 md:w-36 transition-transform duration-100 ease-out will-change-transform"
        style={{
          transform:
            "translate(calc(var(--parallax-x, 0) * -20px), calc(var(--parallax-y, 0) * -20px))",
        }}
      >
        <div className="animate-float-fast opacity-85 mix-blend-normal delay-500">
          <img
            src={bananaImg}
            alt="Banana"
            className="w-full h-full object-contain drop-shadow-xl rotate-12"
          />
        </div>
      </div>

      {/* Mango - Bottom Left */}
      <div
        className="absolute bottom-[20%] left-[10%] w-28 md:w-44 transition-transform duration-100 ease-out will-change-transform"
        style={{
          transform:
            "translate(calc(var(--parallax-x, 0) * 30px), calc(var(--parallax-y, 0) * 30px))",
        }}
      >
        <div className="animate-float-slow opacity-90 mix-blend-normal delay-200">
          <img
            src={mangoImg}
            alt="Mango"
            className="w-full h-full object-contain drop-shadow-2xl -rotate-12"
          />
        </div>
      </div>

      {/* Blurred background elements for depth */}
      <div
        className="absolute top-[40%] right-[40%] w-16 transition-transform duration-100 ease-out will-change-transform"
        style={{
          transform:
            "translate(calc(var(--parallax-x, 0) * 10px), calc(var(--parallax-y, 0) * 10px))",
        }}
      >
        <div className="animate-float-medium opacity-30 mix-blend-overlay blur-[2px]">
          <img
            src={pineappleImg}
            alt=""
            className="w-full h-full object-contain rotate-90"
          />
        </div>
      </div>

      <div
        className="absolute bottom-[40%] left-[30%] w-12 transition-transform duration-100 ease-out will-change-transform"
        style={{
          transform:
            "translate(calc(var(--parallax-x, 0) * -15px), calc(var(--parallax-y, 0) * -15px))",
        }}
      >
        <div className="animate-float-fast opacity-30 mix-blend-overlay blur-[3px]">
          <img
            src={papayaImg}
            alt=""
            className="w-full h-full object-contain -rotate-45"
          />
        </div>
      </div>
    </div>
  );
};
